import React from 'react';
import SvgIcon from 'src/react_components/svg-icon';
import methodHelpers from 'src/utilities/method-helpers';
import QAOverview from './tabs/overview';
import QAGuide from './tabs/guide';
import { ActiveTab, MeetingQaData } from './types.d';

const InfoPanel = (props: MeetingQaData) => {
  const [open, setOpen] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState<ActiveTab>('Overview');
  const toggleShow = () => setOpen(true);
  const close = () => setOpen(false);
  const contentClassName = methodHelpers.buildClassNames({
    'info-panel__content': true,
    'info-panel__content--hidden': !open
  });
  const tabs: ActiveTab[] = ['Overview', 'QA Guide'];
  const overviewActive = activeTab === 'Overview';
  const guideActive = activeTab === 'QA Guide';
  return (
    <div className="info-panel">
      <button type="button" onClick={toggleShow} aria-label="QA Information">
        <SvgIcon
          icon="hamburger-menu"
          className="icon-md"
        />
      </button>
      <div className={contentClassName}>
        <div className="u-flexRigid flex-grow-0 flex-srink-0">
          <h4 className="u-flex u-flexJustifyBetween u-paddingLg d-flex justify-content-between p-4">
            QA Information
            <button
              type="button"
              aria-label="Close QA Information"
              className="u-flex u-flexAlignItemsCenter u-flexJustifyCenter border-0 u-paddingNone u-backgroundNone
                d-flex align-items-center justify-content-center p-0 bg-transparent"
              onClick={close}
            >
              <SvgIcon
                icon="close"
                className="icon-md black u-marginNone m-0"
              />
            </button>
          </h4>
          <ul className="nav nav-tabs view-lg nav-tabs-panel">
            {tabs.map((tab) => (
              <li key={`tab-${tab}`} className={activeTab === tab ? 'active' : ''}>
                <button
                  type="button"
                  className="qa-btn-link btn-link"
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="info-panel__content--body u-paddingHXxl u-paddingTopXs u-flexGrow1
          px-5 pt-1 flex-grow-1"
        >
          <QAOverview active={overviewActive} {...props} />
          <QAGuide active={guideActive} />
        </div>
      </div>
    </div>
  );
};

export default InfoPanel;
